import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, of, switchMap, tap } from 'rxjs';

import { ProfessionalScheduleService } from 'src/app/shared/services/professional-schedule.service';
import { deleteProfessionalSchedule, editProfessionalSchedule, loadProfessionalSchedule, loadProfessionalScheduleSuccess, saveProfessionalSchedule } from './professional-schedule.actions';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Injectable()
export class ProfessionalScheduleEffects {
  constructor(
    private service: ProfessionalScheduleService,
    private action$: Actions,
    private notify: NotifyService
  ) {}

  loadProfessionalSchedule$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadProfessionalSchedule),
      exhaustMap(() =>
        this.service
          .getAll()
          .pipe(
            map((res) => loadProfessionalScheduleSuccess({ lista: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );

  saveProfessionalSchedule$ = createEffect(() =>
    this.action$.pipe(
      ofType(saveProfessionalSchedule),
      concatMap(({ professionalSchedule }) =>
        this.service.save(professionalSchedule).pipe(
          tap(() => this.notify.saveSuccess()),
          switchMap((res) => [loadProfessionalSchedule()]),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  editProfessionalSchedule$ = createEffect(() =>
    this.action$.pipe(
      ofType(editProfessionalSchedule),
      concatMap(({ professionalSchedule, id }) =>
        this.service.edit(professionalSchedule, id).pipe(
          tap(() => this.notify.editSuccess()),
          map((res) => loadProfessionalSchedule()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  deleteProfessionalSchedule$ = createEffect(() =>
    this.action$.pipe(
      ofType(deleteProfessionalSchedule),
      concatMap(({ id }) =>
        this.service.delete(id).pipe(
          tap(() => this.notify.deleteSuccess()),
          map((res) => loadProfessionalSchedule()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );
}
